module.exports = __webpack_public_path__ + "img/thumbnail-compare-sofyre.c96b0d5c.webp";